// Preorder lead-time single source of truth.
// Any user-facing surface showing "preorder XX-YY days" MUST render through
// PREORDER_DAYS_RANGE below (or compose it via the min/max constants).
// Do NOT hard-code numeric lead-time strings at new call sites.

export const PREORDER_LEAD_TIME_MIN_DAYS = 16;
export const PREORDER_LEAD_TIME_MAX_DAYS = 24;

// Hyphen-separated range for inline sentence rendering.
// Example: "16-24"
export const PREORDER_DAYS_RANGE = `${PREORDER_LEAD_TIME_MIN_DAYS}-${PREORDER_LEAD_TIME_MAX_DAYS}`;
